import Client from '../client';
import { AxiosResponse } from 'axios';
import BaseService from '../baseService/baseService';

const DiferencaComissaoService = {
    salvarParametrosExcel(fileRequest: any) {
        return BaseService.conectarEndpoint(fileRequest, 'compensation/diferenca-comissao/excel', 'diferencaComissaoExcelSalvar');
    },
    baixarParametrosExcel(): Promise<void | AxiosResponse<any>> {
        return Client.getBlob('compensation/diferenca-comissao/excel');
    },
    deletarParametrosExcel(request: any) {
        return BaseService.conectarEndpoint(request, 'compensation/diferenca-comissao/deletar', 'diferencaComissaoDeletar');
    },
    reenviarParametrosExcel(): Promise<void | AxiosResponse<any>> {
        return Client.post('compensation/diferenca-comissao/eventGrid', {});
    }
};

export default DiferencaComissaoService;